import React from 'react';
import { Tooltip } from '@xingternal/winery-ui/lib/Tooltip';
import { Icon } from '@xingternal/winery-ui/lib/Icon';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import { PortalBody } from '../../rendering/PortalBody';

type QuestionMarkTooltipProps = {
  tip?: React.ReactNode;
  iconSize?: number;
  onClick?: (event: React.SyntheticEvent) => void;
};

const HoveredIcon = styled(Icon)`
  cursor: pointer;
  :hover {
    fill: ${themeGet('colors.grey400')};
  }
`;

const Bubble = styled(Tooltip.Content)`
  z-index: ${themeGet('zIndices.tooltipLevel')};
`;

const QuestionMarkTooltip = ({
  tip,
  iconSize = 24,
  onClick,
}: QuestionMarkTooltipProps) => (
  <Tooltip>
    <Tooltip.Trigger>
      <HoveredIcon
        name={'CoreHelp'}
        color="grey200"
        width={iconSize}
        height={iconSize}
        onClick={onClick}
      />
    </Tooltip.Trigger>
    {tip && (
      <PortalBody>
        <Bubble>{tip}</Bubble>
      </PortalBody>
    )}
  </Tooltip>
);

export { QuestionMarkTooltip };
